import * as React from 'react';
import { PropsRoute } from '@makemydeal/dr-activities-common';

import type { IRootProps } from '../types';

import Activity from './Activity';
import { getAllRoutes } from '../utils/routes';

const Root: React.FC<IRootProps> = (props: IRootProps) => {
    const path = props.baseRoute;
    const routes = getAllRoutes(path);

    return <PropsRoute {...props} path={routes.ROOT} component={Activity} />;
};

export default Root;
